import { render, staticRenderFns } from "./RedirectionIlluxi.vue?vue&type=template&id=59e3e1e4"
import script from "./RedirectionIlluxi.vue?vue&type=script&lang=js"
export * from "./RedirectionIlluxi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports